import { render, staticRenderFns } from "./FinishCoefHighlight.vue?vue&type=template&id=1a950adc&scoped=true&"
import script from "./FinishCoefHighlight.vue?vue&type=script&lang=js&"
export * from "./FinishCoefHighlight.vue?vue&type=script&lang=js&"
import style0 from "./FinishCoefHighlight.vue?vue&type=style&index=0&id=1a950adc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a950adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
